var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"competition-preview-panel"},[(_vm.currentImage)?_c('img',{staticClass:"preview-image",attrs:{"src":_vm.currentImage,"alt":_vm.imageAlt}}):_c('div',{staticClass:"preview-placeholder"},[_c('i',{staticClass:"fa-regular fa-image"}),_c('span',[_vm._v("Preview not available")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }